module.exports = __webpack_public_path__ + "static/planetway-on-ascii-artwork-1cd0898926f16bbd56066f0144c1a2c0.png";